import BASE_URL from "./BASE_URL";

const SERVER_URL = BASE_URL.replace(/\/api$/, "");

// Build a full URL for a stored "uploads/.." path; pass absolute URLs through.
export const mediaUrl = (path) =>
  !path ? null : path.startsWith("http") ? path : `${SERVER_URL}/${path}`;

// Course card thumbnail (/categories listing): designer image wins, then
// the trailer/video thumbnail from api.video.
export const cardThumb = (course) =>
  mediaUrl(course?.cardImage) ||
  course?.trailer?.assets?.thumbnail ||
  course?.thumbnail ||
  null;

// Big detail image (/course/:slug): designer image wins, else the provided
// api.video fallback (e.g. the main video / trailer thumbnail).
export const bigThumb = (course, apiFallback = null) =>
  mediaUrl(course?.bigThumbnail) || apiFallback || null;

// Per-video thumbnail (inside listing — series episode / playlist lesson):
// the language-resolved designer image wins, else the api.video thumbnail.
export const videoThumb = (video) =>
  mediaUrl(video?.customThumbnail) || video?.assets?.thumbnail || null;
